<div class=" "> 
  <vertical-nav [menuItems]="appS.topMenu" [showMenu]="true" [fullScreen]="true" [title]="title" [profileMenuButtons]="profileMenuButtons()" [showSearch]="true">
    <router-outlet></router-outlet>
  </vertical-nav>
</div>
